import { createContext } from 'react'

import { createKindAllNodeStore } from '../store/createStore'

export const KindAllNodeStoreContext = createContext<
  ReturnType<typeof createKindAllNodeStore> | undefined
>(undefined)
